import React from 'react';
import {motion} from 'framer-motion';

const principles = [
  {
    title: "Clarity",
    text: "Understand the real challenge before defining the response. We prioritize precise diagnosis over rapid assumption."
  },
  {
    title: "Capability",
    text: "Bring the right knowledge, people and resources together. We build teams that possess the specific skills required for the task."
  },
  {
    title: "Action",
    text: "Turn direction into practical and measurable progress. We measure success by real-world outcomes, not theoretical plans."
  }
];

const Philosophy = () => {
  return (
    <section className="py-32 md:py-48 bg-brand-light relative overflow-hidden">
      {/* Soft transition divider */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-brand-primary/5 to-transparent"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-20 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <motion.div 
              initial={{opacity: 0, x: -20}} 
              whileInView={{opacity: 1, x: 0}} 
              viewport={{once: true}} 
              transition={{duration: 0.8}} 
              className="lg:sticky lg:top-40"
            >
              <span className="text-brand-accent text-[11px] tracking-[0.4em] uppercase font-bold mb-8 block">Our Philosophy</span>
              <h2 className="font-display text-4xl md:text-6xl font-light text-brand-primary mb-10 tracking-tight leading-[1.1] text-balance">
                Different fields.<br/>The same commitment to action.
              </h2>
              <p className="text-brand-secondary text-xl font-light leading-relaxed max-w-xl">
                Across EPOQ ventures, the approach is consistent: start with a real need, bring together the right capabilities, and move from idea to practical execution. We believe in long-term thinking, responsible development and strong partnerships that create lasting business value.
              </p>
            </motion.div>
          </div>
          
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col space-y-24">
            {principles.map((p, i) => (
              <motion.div 
                key={p.title} 
                initial={{opacity: 0, y: 20}} 
                whileInView={{opacity: 1, y: 0}} 
                viewport={{once: true}} 
                transition={{duration: 0.8, delay: i * 0.2}} 
                className="relative pl-12 border-l-2 border-brand-secondary/20"
              >
                {/* Brand Accent Indicator */}
                <motion.div 
                  initial={{height: 0}} 
                  whileInView={{height: '100%'}} 
                  viewport={{once: true}} 
                  transition={{duration: 1.2, delay: 0.6 + (i * 0.2)}} 
                  className="absolute left-[-2px] top-0 w-[2px] bg-brand-accent"
                ></motion.div>
                
                <h3 className="font-display text-2xl md:text-3xl text-brand-primary mb-6 tracking-wide font-medium">{p.title}</h3>
                <p className="text-brand-secondary font-light text-lg md:text-xl leading-relaxed">{p.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;